module.exports = __webpack_public_path__ + "static/img/product_images_26_h5_zh.0ff79f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_26_h5_zh.png
// module id = R4n8
// module chunks = 34